module.exports = {
  title: '版本更新设置',
  route: {
    path: '/app-manage',
    children: {
      path: 'app-manage-version-form',
    },
  },
};
